import { useMemo } from 'react'
import { Icon, type TIconProps } from '~/components/icon'
import { useInputTextContext } from '../../input-text'
import type {
  InputTextHelperTextProps,
  InputTextScopedProps,
} from '../../input-text.types'
import { inputTextHelperTextVariants } from './index.styles'

export const InputTextHelperText = ({
  withIcon,
  iconName = 'rdicon-warning-circle',
  children,
  __scopeInputText,
  ...props
}: InputTextScopedProps<InputTextHelperTextProps>) => {
  const { disabled, hasError, readOnly } = useInputTextContext(
    'InputTextHelperText',
    __scopeInputText
  )

  const symbol = hasError ? 'rdicon-warning-circle' : iconName

  const iconColor = useMemo((): TIconProps['color'] => {
    if (disabled) return 'colorTextNeutralDisabled'
    if (readOnly) return 'colorTextNeutralReadonly'
    if (hasError) return 'colorTextDangerAlternative'
    return 'colorTextNeutralAlternative'
  }, [disabled, hasError, readOnly])

  if (!children) return null

  const displayIcon = hasError || withIcon

  return (
    <div
      {...props}
      aria-disabled={disabled}
      className={inputTextHelperTextVariants({
        hasError,
        disabled,
        readOnly,
      })}
    >
      {displayIcon && (
        <div className="flex items-center">
          <Icon symbol={symbol} color={iconColor} size="tiny" />
        </div>
      )}
      <span className="flex flex-1">{children}</span>
    </div>
  )
}
